var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import * as Elements from '../Search.styles';
import { useFilter } from './hooks';
var SearchIconWrap = styled(Elements.IWrap)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  svg {\n    right: auto;\n    left: 0;\n  }\n"], ["\n  svg {\n    right: auto;\n    left: 0;\n  }\n"])));
var Wrapper = styled(Elements.Wrapper)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  input {\n    padding: 0 12px 0 40px;\n  }\n"], ["\n  input {\n    padding: 0 12px 0 40px;\n  }\n"])));
export function Filter(_a) {
    var filterKey = _a.filterKey, delay = _a.delay, placeholder = _a.placeholder, thin = _a.thin, thick = _a.thick, inputClass = _a.inputClass, cy = _a.cy;
    var _b = useFilter({
        filterKey: filterKey,
        delay: delay
    }), search = _b.search, setQuery = _b.setQuery, status = _b.status, clearQuery = _b.clearQuery;
    var handleChange = React.useCallback(function (e) {
        setQuery(e.currentTarget.value);
    }, []);
    return (React.createElement(Wrapper, null,
        React.createElement(Elements.StyledSearch, { thin: thin, thick: thick },
            React.createElement(SearchIconWrap, { "data-testid": "PrimarySearch-search", appearance: "plain", thin: thin, thick: thick },
                React.createElement(Elements.SearchIcon, { className: "t-SearchIcon", thin: thin, thick: thick })),
            React.createElement("input", { value: search, "data-cy": cy, className: inputClass, "data-testid": "PrimarySearch-input", type: "search", placeholder: placeholder, onChange: handleChange }),
            status !== 'empty' ? (React.createElement(Elements.IWrap, { "data-testid": "PrimarySearch-clear", appearance: "plain", onClick: clearQuery, thin: thin, thick: thick },
                React.createElement(Elements.ClearIcon, { className: "t-ClearIcon", small: true, thin: thin, thick: thick }))) : null)));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=Filter.js.map